import { render, staticRenderFns } from "./showRefs.vue?vue&type=template&id=1787c432&"
import script from "./showRefs.vue?vue&type=script&lang=js&"
export * from "./showRefs.vue?vue&type=script&lang=js&"
import style0 from "./showRefs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1787c432', component.options)
    } else {
      api.reload('1787c432', component.options)
    }
    module.hot.accept("./showRefs.vue?vue&type=template&id=1787c432&", function () {
      api.rerender('1787c432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/VerFacturacion/showRefs.vue"
export default component.exports